module.exports = __webpack_public_path__ + "static/hill-a4bd9e2b88ef1ff48ff53ec83002caed.jpg";